<script lang="ts">
  export let handleConfirmEvent!: any;

  const handleConfirm = (): void => {
    handleConfirmEvent();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">キャンペーン違約金について</h1>
    </div>
  </div>
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="flex-1 m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>
            適用中のキャンペーンにおいては、開通月の翌月を基準として1年ごとの応当月以外に解約する場合、キャンペーン違約金(9,500円)が必要となります。
          </p>
          <p class="mt-4">
            例)2022年7月に開通した場合、開通月翌月は2022年8月となり、その1年ごとの応当月2023年8月、2024年8月、、、以外に解約する場合、9,500円の違約金が必要となります
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
